/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { customSVGs } from '@/components/icons/customIcons'
import { md3 } from 'vuetify/blueprints'
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides

const haskoningLight = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#009EAB',
    secondary: '#009EAB',
    highlight: '#CCECEE',
    speckleColor: '#047EFB'
  }
}

export default createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: 'haskoningLight',
    themes: {
      haskoningLight: haskoningLight
    }
  },
  icons: {
    iconFont: 'mdiSvg',
    sets: {
      custom: customSVGs
    }
  },
  defaults: {
    VTextField: {
      variant: 'filled'
    },
    VSelect: {
      variant: 'filled'
    },
    VFileInput: {
      variant: 'filled'
    },
    VAutocomplete: {
      variant: 'filled'
    },
    VTextarea: {
      variant: 'filled'
    }
  }
})
